import { CategoriesStore } from '../stores/categories-store'
import { DataSetStore } from '../stores/data-sets-store'
import { DocumentMetadataStore } from '../stores/document-metadata-store'
import { DocumentUploadStore } from '../stores/document-upload-store'
import { DocumentsStore } from '../stores/documents-store'
import { ManufacturerStore } from '../stores/manufacturers-store'
import { ModelsStore } from '../stores/models-store'
import { OrganizationDataGrantsStore } from '../stores/organization-data-grants-store'
import { OrganizationDataSetsStore } from '../stores/organization-data-sets-store'
import { OrganizationDomainsStore } from '../stores/organization-domains-store'
import { OrganizationInvitationCodesStore } from '../stores/organization-invitation-codes-store'
import { OrganizationMembersStore } from '../stores/organization-members-store'
import { OrganizationStore } from '../stores/organization-store'
import { PromptsStore } from '../stores/prompts-store'
import { AgentPromptsStore } from '../stores/agent-prompts-store'
import { QueueTasksStore } from '../stores/queue-tasks-store'
import { TestQuestionsStore } from '../stores/test-questions-store'
import { TestRunsStore } from '../stores/test-runs-store'
import { UserStore } from '../stores/user-store'
import { WorkOrdersStore } from '../stores/work-orders-store'
import { WOManufacturerModelMatchStore } from '../pages/organization-details/pages/wo-model-manufacturer-match/wo-model-manufacturer-match-store'

export class Stores {
    // remember to create an instance below when adding a new store
    public documentUploads: DocumentUploadStore
    public documentMetadata: DocumentMetadataStore
    public documents: DocumentsStore
    public workOrders: WorkOrdersStore
    public organizations: OrganizationStore
    public organizationMembers: OrganizationMembersStore
    public organizationDataSets: OrganizationDataSetsStore
    public users: UserStore
    public organizationCodes: OrganizationInvitationCodesStore
    public organizationDomains: OrganizationDomainsStore
    public organizationDataGrants: OrganizationDataGrantsStore
    public dataSets: DataSetStore
    public manufacturers: ManufacturerStore
    public categories: CategoriesStore
    public models: ModelsStore
    public manufacturerModelMatch: WOManufacturerModelMatchStore
    public testQuestions: TestQuestionsStore
    public testRuns: TestRunsStore
    public prompts: PromptsStore
    public agentPrompts: AgentPromptsStore
    public queueTasks: QueueTasksStore

    constructor() {
        this.documentUploads = new DocumentUploadStore(this)
        this.documentMetadata = new DocumentMetadataStore(this)
        this.documents = new DocumentsStore(this)
        this.workOrders = new WorkOrdersStore()
        this.organizations = new OrganizationStore()
        this.organizationMembers = new OrganizationMembersStore()
        this.organizationDataSets = new OrganizationDataSetsStore(this)
        this.users = new UserStore()
        this.organizationCodes = new OrganizationInvitationCodesStore()
        this.organizationDomains = new OrganizationDomainsStore()
        this.organizationDataGrants = new OrganizationDataGrantsStore()
        this.dataSets = new DataSetStore(this)
        this.manufacturers = new ManufacturerStore(this)
        this.categories = new CategoriesStore()
        this.models = new ModelsStore(this)
        this.manufacturerModelMatch = new WOManufacturerModelMatchStore()
        this.testQuestions = new TestQuestionsStore()
        this.testRuns = new TestRunsStore()
        this.prompts = new PromptsStore()
        this.agentPrompts = new AgentPromptsStore()
        this.queueTasks = new QueueTasksStore()
    }
}
